import { render, staticRenderFns } from "./tilbud.vue?vue&type=template&id=378dba5a&"
import script from "./tilbud.vue?vue&type=script&lang=js&"
export * from "./tilbud.vue?vue&type=script&lang=js&"
import style0 from "./tilbud.vue?vue&type=style&index=0&id=378dba5a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports